import { TFunction } from "i18next";

export function criticalErrorMailLink(
  translate: TFunction<"translation", undefined>,
) {
  const feedbackEmail = "vygruppen@service-now.com";
  const ccEmail = "team-brukerflater-drops@vy.no";
  const subject = encodeURIComponent(
    translate("Kritisk feil i DROPS Dashboard"),
  );

  const body = encodeURIComponent(`
      1. ${translate("Hva skjedde, og hvor i Dashboard?")}

      2. ${translate("Når skjedde det? Har det skjedd flere ganger?")}

      3. ${translate("Hva gjorde du? Beskriv kort stegene frem til feilen oppstod slik at vi kan reprodusere det.")}

      4. ${translate("Hva forventet du skulle skje?")}

      ${translate("Legg gjerne ved et skjermbilde av hele skjermen (Windows + Shift + S).")}

      ${translate("Takk for hjelpen! Vi besvarer mailen fortløpende innen normale arbeidstider.")}
  `);

  return `mailto:${feedbackEmail}?cc=${ccEmail}&subject=${subject}&body=${body}`;
}

export function otherErrorMailLink(
  translate: TFunction<"translation", undefined>,
) {
  const feedbackEmail = "team-brukerflater-drops@vy.no";
  const subject = encodeURIComponent(translate("Feil i DROPS Dashboard"));

  const body = encodeURIComponent(`
      1. ${translate("Hva skjedde, og hvor i Dashboard?")}

      2. ${translate("Når skjedde det? Har det skjedd flere ganger?")}

      3. ${translate("Hva gjorde du? Beskriv kort stegene frem til feilen oppstod slik at vi kan reprodusere det.")}

      4. ${translate("Hva forventet du skulle skje?")}

      ${translate("Legg gjerne ved et skjermbilde av hele skjermen (Windows + Shift + S).")}

      ${translate("Takk for hjelpen! Vi besvarer mailen innen normale arbeidstider.")}
  `);

  return `mailto:${feedbackEmail}?subject=${subject}&body=${body}`;
}
